import styled from 'styled-components/macro'

const MainContent = styled("div")`
 width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    padding:5rem 10%;
    text-align: center;
` as any;

export {MainContent}